import axios from "axios";
import { Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Cookies } from "react-cookie";
import Loading from "components/ui/loading";
import { loadAlert } from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";

const cookies = new Cookies();

export default function BestItems() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [productList, setProductList] = useState("");
  const [token, setToken] = useState("");
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    setFetching(true);
    setToken(cookies.get("X-AUTH-TOKEN"));
    loadList();
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) {
      setFetching(true);
      setToken(cookies.get("X-AUTH-TOKEN"));
      loadList();
    }
  }, [init]);

  const loadList = () => {
    let favInfo = cookies.get("favInfo");

    axios
      .get(`/api/eh/product/main`, {
        params: {
          schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
          pgSz: 100,
        },
      })
      .then((res) => {
        setProductList(res.data.data.productList);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const handleFav = (item) => {
    if (token) {
      axios
        .post("/api/eh/product/favorite/fav", {
          seq: item.seq,
        })
        .then((res) => {
          loadList();
          console.log("item", item);
        });
    } else {
      dispatch(loadAlert(true));
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <div className="bestItems">
        <Grid contianer className="list-wrap">
          {productList &&
            productList.list.map((item, i) => (
              <Grid
                item
                key={i}
                className="item"
                onClick={() => {
                  history.push({
                    pathname: `/product-of-week/detail/${item.seq}`,
                    props: {
                      seq: item.seq,
                    },
                  });
                }}
              >
                <div className="item-img">
                  <div className="img-wrap">
                    <img src={item.prodImgUrl} />
                  </div>
                  {item.dcMak && (
                    <div className="badge">
                      <div className="txt">{item.dcMak}</div>
                    </div>
                  )}
                </div>
                <div className="tit">{item.ttl}</div>
                {item.prchTrms && (
                  <div className="sub-tit">{item.prchTrms}</div>
                )}
                <div className="price">
                  {item.prc.toLocaleString()}
                  <span>원</span>
                </div>
                {item.dcTp && (
                  <>
                    <div className="grey-box">{item.dcTp}</div>
                  </>
                )}
                {item.prmtCont && (
                  <div className="red-box">{item.prmtCont}</div>
                )}
                {item.qty && (
                  <div className="cnt">
                    한정수량 {item.qty.toLocaleString()}개
                  </div>
                )}

                <div className="func-btn">
                  <Button
                    className="fav"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFav(item, i);
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icon/favorite${
                        item.favYn == "Y" ? "" : "-off-d"
                      }.svg`}
                    />
                    <span
                      style={{
                        color: item.favYn == "Y" ? "#F1270B" : "#bebebe",
                      }}
                    >
                      {item.favCnt}
                    </span>
                  </Button>
                  <Button
                    className="fav"
                    // onClick={() => {
                    //   handleFav(item, i);
                    // }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icon/review.svg`}
                    />
                    <span
                      style={{
                        color: "#bebebe",
                        // color: item.rvYn == "Y" ? "#F1270B" : "#bebebe",
                      }}
                    >
                      {item.rvCnt}
                    </span>
                  </Button>
                </div>
              </Grid>
            ))}
        </Grid>
      </div>
    </>
  );
}
